import { render } from "./Buy.vue?vue&type=template&id=43654fd7&scoped=true"
import script from "./Buy.vue?vue&type=script&lang=js"
export * from "./Buy.vue?vue&type=script&lang=js"

import "./Buy.vue?vue&type=style&index=0&id=43654fd7&lang=scss"
import "./Buy.vue?vue&type=style&index=1&id=43654fd7&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-43654fd7"]])

export default __exports__